// extracted by mini-css-extract-plugin
module.exports = {"card":"component_card__1beq3"};